<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Credit Or Voucher</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSubmit()">

    <div class="modal-body">

      <div class="form-group">
        <label for="typeSelect">Type</label>
        <select class="custom-select" id="typeSelect" name="type"
                [(ngModel)]="selectedType" required>
          <option value="{{ TYPE_CREDIT }}">{{ TYPE_CREDIT }}</option>
          <option value="{{ TYPE_VOUCHER }}">{{ TYPE_VOUCHER }}</option>
        </select>
      </div>

      <ng-container *ngIf="selectedType === TYPE_CREDIT">
        <div class="form-group">
          <label for="amountInput">Value</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ organizationConfigService.getCurrencySymbol() }}</span>
            </div>
            <input id="amountInput" type="number" min="0.01" step="0.01"
                   class="form-control" name="amount" required
                   [(ngModel)]="credit.amount_total">
          </div>
          <div class="form-text text-danger">
            {{ errors.amount_total }}
          </div>
        </div>

        <div class="form-group">
          <label for="creditExpiryDateInput">Expiry Date</label>
          <app-date-picker [id]="'creditExpiryDateInput'"
                           [(content)]="credit.expiry_date"></app-date-picker>
          <div class="form-text text-danger">
            {{ errors.expiry_date }}
          </div>
        </div>

        <div class="custom-control custom-checkbox mb-3">
          <input type="checkbox" class="custom-control-input"
                 id="will_apply_to_recurring_payments"
                 name="will_apply_to_recurring_payments"
                 [(ngModel)]="credit.will_apply_to_recurring_payments">
          <label class="custom-control-label" for="will_apply_to_recurring_payments">
            This credit will apply to recurring membership payments
          </label>
        </div>

        <div class="indented-subsection">
          <div class="custom-control custom-checkbox mb-3"
               *ngIf="credit.will_apply_to_recurring_payments">
            <input type="checkbox" class="custom-control-input"
                   id="only_applies_to_recurring_payments"
                   name="only_applies_to_recurring_payments"
                   [(ngModel)]="credit.only_applies_to_recurring_payments">
            <label class="custom-control-label" for="only_applies_to_recurring_payments">
              This credit may only apply to recurring membership payments
            </label>
            <small class="form-text text-muted">
              If enabled, this credit will only apply to automatic recurring payments. It cannot be used for the initial purchase of a recurring membership.
            </small>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedType === TYPE_VOUCHER">
        <div class="form-group">
          <label for="useVoucherEventType">Voucher Type</label>
          <select id="useVoucherEventType" name="useVoucherEventType"
                  class="custom-select"
                  [(ngModel)]="useVoucherEventType"
                  (ngModelChange)="clearVoucherEventTypeAndCategory()">
            <option [ngValue]="true">Event Type</option>
            <option [ngValue]="false">Event Category</option>
          </select>
        </div>

        <div class="form-group" *ngIf="useVoucherEventType">
          <label for="eventTypeSelect">Event Type</label>
          <select id="eventTypeSelect" class="custom-select" name="eventType"
                  [(ngModel)]="voucher.event_type_id" *ngIf="!loadingEventTypes" required>
            <option [ngValue]="null" disabled>---</option>
            <option *ngFor="let eventType of eventTypeList"
                    [ngValue]="eventType.id">
              {{ eventType.name }}
              <ng-container *ngIf="eventType.status === EventTypeStatus.retired">(Retired)</ng-container>
            </option>
          </select>
          <select id="eventTypeSelectLoading" class="custom-select" name="eventType"
                  [(ngModel)]="voucher.event_type_id" *ngIf="loadingEventTypes" disabled>
            <option selected>Loading...</option>
          </select>
          <div class="form-text text-danger">
            {{ errors.event_type_id }}
          </div>
        </div>

        <div class="form-group" *ngIf="!useVoucherEventType">
          <label for="event_category_id">Event Category</label>
          <select id="event_category_id" class="custom-select" name="event_category_id"
                  [(ngModel)]="voucher.event_category_id" *ngIf="!loadingEventCategories" required>
            <option [ngValue]="null" disabled>---</option>
            <option *ngIf="eventCategoryRemoved(voucher.event_category_id)"
                    [ngValue]="voucher.event_category_id">
              {{ voucher.event_category_name }} (Removed)
            </option>
            <option *ngFor="let eventCategory of eventCategoryList"
                    [ngValue]="eventCategory.id">
              {{ eventCategory.name }}
            </option>
          </select>
          <select id="eventCategorySelectLoading" class="custom-select" name="event_category_id"
                  [(ngModel)]="voucher.event_category_id" *ngIf="loadingEventCategories" disabled>
            <option selected>Loading...</option>
          </select>
          <div class="form-text text-danger">
            {{ errors.event_category_id }}
          </div>
        </div>

        <div class="form-group">
          <label for="numberInput">Number of Vouchers</label>
          <input id="numberInput" type="number" min="1" step="1"
                 class="form-control" name="amount" required
                 [(ngModel)]="voucher.number_of_uses_total">
          <div class="form-text text-danger">
            {{ errors.number_of_uses_total }}
          </div>
        </div>

        <div class="form-group">
          <label for="voucherExpiryDateInput">Expiry Date (Optional)</label>
          <app-date-picker [id]="'voucherExpiryDateInput'"
                           [(content)]="voucher.expiry_date"></app-date-picker>
          <div class="form-text text-danger">
            {{ errors.expiry_date }}
          </div>
        </div>
      </ng-container>

      <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary"
              (click)="activeModal.close()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary"
              *ngIf="!isLoading()">
        Save
      </button>
      <button type="button" class="btn btn-primary disabled" disabled
              *ngIf="isLoading()">
        Loading...
      </button>
    </div>

  </form>

</ng-container>
